import { withDisplayName } from '@hocs/with-display-name'
import RichText from '@resolvers/rich-text'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import { Divider } from '@ui/atoms/Divider'
import { Card } from '@ui/card/card'
import { EnhancedButton } from '@ui/enhanced-components/enhanced-components'
import { Hyperlink } from '@ui/hyperlink'
import { graphql } from 'gatsby'
import React, { Fragment } from 'react'

const ContentfulLegacyEtapier: Utils.EntryFC<
  Queries.ContentfulLegacyEtapierFragment
> = ({
  content: {
    condition1,
    condition2,
    condition3,
    condition4,
    condition5,
    conditionDetails,
    infoTitle,
    infoText,
    infoLinkText,
    infoLinkUrl,
    bigLinkText,
    bigLinkUrl,
    smallLinkText,
    smallLinkUrl,
  },
  entryInspectorProps,
  fieldInspectorProps,
}) => {
  const conditionArray = [
    condition1,
    condition2,
    condition3,
    condition4,
    condition5,
  ].filter((condition) => Boolean(condition?.rich))

  return (
    <div
      className="grid grid-cols-1 gap-4 tablet:grid-cols-2"
      {...entryInspectorProps()}
    >
      <div>
        <ul>
          {conditionArray.map((condition, index) => (
            <Fragment key={`content-open-account-item-${index}`}>
              <li className="flex gap-4 px-4 py-2">
                <div>
                  <div className="flex h-10 w-10 items-center justify-center bg-[#bdbdbd] text-115 text-theme-primary-accent1">
                    {index + 1}
                  </div>
                </div>
                <div>
                  <RichText
                    content={condition}
                    options={defaultRichTextFieldOptionsDeprecated}
                  />
                </div>
              </li>
              {index < conditionArray.length - 1 && <Divider />}
            </Fragment>
          ))}
        </ul>
        {conditionDetails && (
          <RichText
            {...fieldInspectorProps({
              fieldId: 'conditionDetails',
            })}
            content={conditionDetails}
            options={defaultRichTextFieldOptionsDeprecated}
          />
        )}
      </div>
      <div>
        {(infoTitle || infoText) && (
          <div className="mb-3">
            <Card>
              <div className="p-10">
                <h3
                  className="text-balance text-110"
                  {...fieldInspectorProps({
                    fieldId: 'infoTitle',
                  })}
                >
                  {infoTitle.text}
                </h3>
                <RichText
                  {...fieldInspectorProps({
                    fieldId: 'infoText',
                  })}
                  content={infoText}
                  options={defaultRichTextFieldOptionsDeprecated}
                />
                <Hyperlink href={infoLinkUrl}>
                  <RichText
                    {...fieldInspectorProps({
                      fieldId: 'infoLinkText',
                    })}
                    content={infoLinkText}
                    options={defaultRichTextFieldOptionsDeprecated}
                  />
                </Hyperlink>
              </div>
            </Card>
          </div>
        )}
        {bigLinkText && bigLinkUrl && (
          <EnhancedButton className="w-full" href={bigLinkUrl}>
            {bigLinkText.text}
          </EnhancedButton>
        )}
        {smallLinkText && smallLinkUrl && (
          <EnhancedButton
            className="w-full"
            href={smallLinkUrl}
            variant="secondary"
          >
            {smallLinkText.text}
          </EnhancedButton>
        )}
      </div>
    </div>
  )
}

export const query = graphql`
  fragment ContentfulLegacyEtapier on Contentful3KdsMhn4HaYi80YIgAOoYq {
    ...ContentfulEntry
    condition1 {
      rich
    }
    condition2 {
      rich
    }
    condition3 {
      rich
    }
    condition4 {
      rich
    }
    condition5 {
      rich
    }
    conditionDetails {
      rich
    }
    infoTitle {
      rich
      text
    }
    infoText {
      rich
      text
    }
    infoLinkText {
      rich
      text
    }
    infoLinkUrl
    bigLinkText {
      rich
      text
    }
    bigLinkUrl
    smallLinkText {
      rich
      text
    }
    smallLinkUrl
  }
`

export default withDisplayName(
  ContentfulLegacyEtapier,
  'ContentfulLegacyEtapier'
)
